export default __webpack_public_path__ + "media/images/icons/consultancy-outline-566fb38738647e94de7d53b6c9a10de7.svg";